import {graphql} from 'react-relay';
import Util from '../forecast-app/shared/util/util';
import {trackAndCommitMutation} from '../tracking/amplitude/TrackMutation';

/**
 * FOR-82 (BU-10e) support tool — mint + fetch a fresh Customer Portal magic link
 * for a user (no email sent). Proxies through graphql/ to the portal internal admin
 * API. onCompleted receives {generatePortalUserInviteLink: {url, expiresAt}}.
 */
const mutation = graphql`
	mutation generatePortalUserInviteLinkMutation($input: GeneratePortalUserInviteLinkInput!) {
		generatePortalUserInviteLink(input: $input) {
			url
			expiresAt
		}
	}
`;

function commit(environment, input, onSuccess, onError) {
	const variables = {input: {csrfToken: Util.getCsrfValue(), socketClientId: Util.getClientId(), ...input}};
	return trackAndCommitMutation(environment, {mutation, variables, onCompleted: onSuccess, onError}, true);
}

export default {commit};
